import react, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import Loader from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import { onMessageListener } from "../../utils/pushNotification";

import { getAllJobsByAdditionalPayment } from "../../Redux/Actions/additionalPayment";
import { useSortableData } from "../../utils/sortableData";
import { clearSession } from "../../utils/initiate";
import { useTranslation } from "react-i18next";
import {
  getLocaleValue,
  dateFormat,
  dateTimeFormat,
  dateTimeFormat12,
} from "../../utils";
import DataCount from "../../utils/dataCount";

function AdditionalPaymentList({ history }) {
  let itemsPerPage = 10;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [additionalPaymentData, setAdditionalPaymentData] = useState([]);
  const { items, requestSort, sortConfig } = useSortableData(
    additionalPaymentData
  );

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % additionalPaymentData.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    let payload = {
      jobId: 0,
      fromDate: "",
      toDate: "",
      status: "",
    };
    setLoading(true);
    getAllJobsByAdditionalPayment(payload)
      .then((res) => {
        if (res?.data) {
          setAdditionalPaymentData(res.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  }, []);

  onMessageListener().then(payload => {
    console.log(payload);
}).catch(err => console.log('failed: ', err));

  return (
    <div>
       <div className="container-fluid">
      <div className="page-title-box">
        <h4 className="page-title my-2">
          {getLocaleValue("additional_payments")}
        </h4>
      </div>
      <div style={{ justifyContent: "center", marginTop: "10px" }}>
        {loading ? (
          <Loader
            type="ThreeDots"
            color="#ad1a5f"
            height={40}
            width={40}
            style={{ textAlign: "center", marginBottom: "50px" }}
          />
        ) : additionalPaymentData.length ? (
          // additionalPaymentData.map(({ title, message, documentURL }) => {
          //   return (
            <div
            className="card card-custom card-stretch gutter-b"
            style={{ marginTop: "10px" }}
          >
            <div className="card-body py-3">
          <div
            className="table-responsive"
            style={{ width: "100%", overflowX: "scroll" }}
          >
            <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
              <thead>
                <tr className="text-left">
                  <th
                    className="c-pointer"
                    style={{ width: "75px" }}
                    onClick={() => requestSort("id")}
                  >
                    <span
                      className={
                        sortConfig && sortConfig.key === "id"
                          ? "text-secondary"
                          : "text-dark-75" + " font-15"
                      }
                    >
                      {getLocaleValue("jobid")}{" "}
                      {sortConfig &&
                        sortConfig.key === "id" &&
                        (sortConfig.direction === "ascending" ? (
                          <FiArrowUp />
                        ) : (
                          <FiArrowDown />
                        ))}
                    </span>
                  </th>
                  <th
                    className="c-pointer"
                    style={{ width: "150px" }}
                    onClick={() => requestSort("createdTime")}
                  >
                    <span
                      className={
                        sortConfig && sortConfig.key === "createdTime"
                          ? "text-secondary"
                          : "text-dark-75" + " font-15"
                      }
                    >
                      {t("jobsManagement.manageJobs.dateTime")}{" "}
                      {sortConfig &&
                        sortConfig.key === "createdTime" &&
                        (sortConfig.direction === "ascending" ? (
                          <FiArrowUp />
                        ) : (
                          <FiArrowDown />
                        ))}
                    </span>
                  </th>

                  

                  <th
                    className="c-pointer"
                    style={{ width: "200px" }}
                    onClick={() => requestSort("typeName")}
                  >
                    <span
                      className={
                        sortConfig && sortConfig.key === "typeName"
                          ? "text-secondary"
                          : "text-dark-75" + " font-15"
                      }
                    >
                      {getLocaleValue("name")}{" "}
                      {sortConfig &&
                        sortConfig.key === "typeName" &&
                        (sortConfig.direction === "ascending" ? (
                          <FiArrowUp />
                        ) : (
                          <FiArrowDown />
                        ))}
                    </span>
                  </th>
                  <th
                    className="c-pointer"
                    style={{ width: "150px" }}
                    onClick={() => requestSort("status")}
                  >
                    <span
                      className={
                        sortConfig && sortConfig.key === "status"
                          ? "text-secondary"
                          : "text-dark-75" + " font-15"
                      }
                    >
                      {t("jobsManagement.manageJobs.status")}{" "}
                      {sortConfig &&
                        sortConfig.key === "status" &&
                        (sortConfig.direction === "ascending" ? (
                          <FiArrowUp />
                        ) : (
                          <FiArrowDown />
                        ))}
                    </span>
                  </th>
                  <th
                    style={{
                      width: "100px",
                      position: "sticky",
                      left: "0px",
                      zIndex: "40",
                    }}
                  >
                    <span className="text-dark-75 font-15">
                      {t("customerJobReport.manageInformation.action")}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map(({ id, status, typeName, createdTime, jobId, isPendingDues }) => {
                  let statusClass =
                    status.toLowerCase() === "completed"
                      ? "success"
                      : status.toLowerCase() === "cancelled"
                      ? "danger"
                      : "warning";
                  return (
                    <tr key={id}>
                      <td>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                          {jobId}
                        </span>
                      </td>

                      <td>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                          {dateTimeFormat(createdTime)}
                        </span>
                      </td>

                      
                      <td style={{ whiteSpace: "wrap" }} className="pl-0 py-8">
                        <div className="d-flex">
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                            {typeName}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span
                          className={"label me-1 label-outline-" + statusClass}
                          style={{
                            borderRadius: "3px",
                            width: "auto",
                          }}
                        >
                          {status}
                        </span>
                      </td>
                      {isPendingDues && (
                        <td className="pr-0" style={{ position: "sticky" }}>
                          <div>
                            <div className="c-pointer">
                              <button
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => {
                                  history.push(
                                    `/additionalPayment/${jobId}`
                                  );
                                }}
                              >
                                {" "}
                                {getLocaleValue("additional_payment")}
                              </button>
                              {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    class="bi bi-three-dots"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                  </svg> */}
                            </div>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {pageCount > 1 && (
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                previousLabel="<"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            )}
            {additionalPaymentData.length === 0 && (
              <p className="text-center mt-5 mb-5">
                {t("jobsManagement.noDataAvailable")}
              </p>
            )}
          </div>
          </div></div>
        ) : (
          // );
          // })
          <div
            className="card"
            style={{ padding: "20px", marginRight: "10px" }}
          >
            <div style={{ justifyContent: "center", display: "flex" }}>
              {t("extra.no_data_available")}
            </div>
          </div>
        )}
        {additionalPaymentData.length > 0 && (
          <DataCount itemOffset={itemOffset} items={items} />
        )}
      </div>
      </div>
    </div>
  );
}

export default AdditionalPaymentList;
